import detailMesin from "./state";
import latestVersionMesin from "./state";
import createMesinData from "./state";

import {dataCreateMesin, pagination} from "./state"

const mutations = {
    setListSnapMesin: (state, res) => {
        if (state.listSnapMesin.data !== undefined) {
            if (res.data === null) {
                return
            }
            state.listSnapMesin.data = [...state.listSnapMesin.data, ...res.data];
        } else {
            state.listSnapMesin = res
        }
    },
    setReportConnectionMesin: (state, res) => {
        if (state.reportConnectionMesin.data !== undefined) {
            state.reportConnectionMesin.data = [...state.reportConnectionMesin.data, ...res.data]
        } else {
            state.reportConnectionMesin = res
        }
    },
    setLayananByAid: (state, res) => {
        if (state.layananByAid.data !== undefined) {
            state.layananByAid.data = {...state.layananByAid.data, ...res.data}
        } else {
            state.layananByAid = res
        }
    },
    setLatestVerionMesin: (state, res) => {
        state.latestVersionMesin = res
    },
    setDetailMesin: (state, res) => {
        state.detailMesin = res
    },
    setTagMesin: (state, res) => {
        state.listTagMesin = res
    },

    setListMesinUrut: (state, res) => {
        state.listMesinUrut = res
    },
    setDataCreateMesin: (state, data) => {
        state.createMesinData = data
    },

    setNextPagination: (state, payload) => {
        state.pagination.length = (payload.data ?? []).length
        state.pagination.pageNumber++
        state.pagination.offset = state.pagination.pageNumber * state.pagination.limit
    },
    setSearchKey: (state, {searchKey}) => {
        state.searchKey = searchKey
    },

    resetListSnapMesin: (state) => state.listSnapMesin = [],
    resetListTagMesin: (state) => state.listTagMesin = [],
    resetReportConnectionMesin: (state) => state.reportConnectionMesin = [],
    resetLayananByAid: state => state.layananByAid = [],
    resetDetail: state => state.detailMesin = {},
    resetLatVer: state => state.latestVersionMesin = {},
    resetDataCreateMesin: state => state.createMesinData = dataCreateMesin(),
    resetPagination: state => state.pagination = pagination(),
    resetSearchKey: state => state.searchKey = ""
}

export default mutations